/* Loyalty progress bar - cart */
(function () {
  function formatMoney(cents) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function renderLoyalty(cartTotalCents) {
    var blocks = document.querySelectorAll('.js-cart-loyalty-progress');

    if (!blocks.length) return;

    blocks.forEach(function (wrapper) {
      var message = wrapper.querySelector('.js-cart-loyalty-message');
      var fill = wrapper.querySelector('.js-cart-loyalty-bar-fill');

      if (!message || !fill) return;

      var threshold5 = Number(wrapper.getAttribute('data-threshold-5')) || 5000;
      var threshold10 = Number(wrapper.getAttribute('data-threshold-10')) || 10000;

      if (cartTotalCents < threshold5) {
        var left5 = threshold5 - cartTotalCents;

        message.innerHTML =
          '🎁 Vous bénéficiez déjà de <strong>3% de réduction automatique</strong>. ' +
          'Plus que <strong>' + formatMoney(left5) + '</strong> pour atteindre le palier <strong>5% de réduction</strong>.';
      } else if (cartTotalCents < threshold10) {
        var left10 = threshold10 - cartTotalCents;

        message.innerHTML =
          '🎉 Vous avez atteint le palier <strong>5% de réduction</strong>. ' +
          'Plus que <strong>' + formatMoney(left10) + '</strong> pour atteindre le palier <strong>10% de réduction</strong>.';
      } else {
        message.innerHTML =
          '🏆 Vous avez atteint le meilleur palier : <strong>10% de réduction</strong>.';
      }

      var progress = Math.min((cartTotalCents / threshold10) * 100, 100);
      fill.style.transform = 'scaleX(' + progress / 100 + ')';
      fill.setAttribute('data-progress', Math.round(progress));
    });
  }

  function refreshLoyalty() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderLoyalty(cart.total_price);
      })
      .catch(function () {
        var messages = document.querySelectorAll('.js-cart-loyalty-message');

        messages.forEach(function (message) {
          message.innerHTML =
            'Votre palier fidélité sera calculé automatiquement dans le panier.';
        });
      });
  }

  function refreshWithDelay() {
    setTimeout(refreshLoyalty, 250);
    setTimeout(refreshLoyalty, 750);
    setTimeout(refreshLoyalty, 1500);
  }

  refreshLoyalty();

  document.addEventListener('DOMContentLoaded', refreshLoyalty);
  window.addEventListener('load', refreshLoyalty);

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('button') ||
      event.target.closest('a[href*="/cart"]') ||
      event.target.closest('.cart-remove-button') ||
      event.target.closest('[name="plus"]') ||
      event.target.closest('[name="minus"]')
    ) {
      refreshWithDelay();
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.matches('.quantity__input') ||
      event.target.closest('quantity-input')
    ) {
      refreshWithDelay();
    }
  });

  document.addEventListener('cart:updated', refreshLoyalty);
  document.addEventListener('cart:change', refreshLoyalty);
  document.addEventListener('cart:refresh', refreshLoyalty);
  document.addEventListener('cart:rendered', refreshLoyalty);

  var originalFetch = window.fetch;

  window.fetch = function () {
    var args = arguments;

    return originalFetch.apply(this, args).then(function (response) {
      try {
        var url = args[0];

        if (
          typeof url === 'string' &&
          (
            url.indexOf('/cart/add') !== -1 ||
            url.indexOf('/cart/change') !== -1 ||
            url.indexOf('/cart/update') !== -1 ||
            url.indexOf('/cart/clear') !== -1
          )
        ) {
          refreshWithDelay();
        }
      } catch (e) {}

      return response;
    });
  };
})();